import styled from 'styled-components'

import { BaseBadgeStyles, type IBaseBadgeProps } from './BaseBadgeStyles'

export const DiscoverBadgeStyled = styled.span<IBaseBadgeProps>`
  ${BaseBadgeStyles}

  gap: ${(props) => props.theme.space.xsmall};

  color: ${(props) => props.theme.colors.badge.discover.content};
  background: ${(props) => props.theme.colors.badge.discover.background};
`
